
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  BalanceItem,
  DEVICE_TYPE_AC,
  DEVICE_TYPE_ACCEPTOR,
  DEVICE_TYPE_RE,
  DEVICE_TYPE_RECYCLER,
} from "./dashboard.type";
import { PMiniLabel, PPiePercentage } from "@/common/components";
import DateTimeMixin from "@/mixins/datetime";
import { User } from "@/entities";
import { Getter } from "vuex-class";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";

@Component({
  mixins: [DateTimeMixin],
  components: {
    PMiniLabel,
    PIcon,
    PPiePercentage,
  },
})
export class BalancesDashboard extends Vue {
  @Getter("getLoggedUser") loggedUser?: User;
  @Prop({ required: true }) balance!: BalanceItem;

  get hasNotes(): boolean {
    if (!this.balance || !this.balance.balances || !Array.isArray(this.balance.balances)) {
      return false;
    }
    return !this.balance.balances.some((balance) => balance.noteCapacity === null);
  }

  iconSP = "IconServicePoint";

  numberOptions = {
    style: "decimal",
    minimumFractionDigits: 2,
    useGrouping: true,
  };
  notesOptions = {
    useGrouping: true,
  };

  get iconType(): string {
    return this.iconSP;
  }

  get loggedUserHasSeveralEntities(): boolean {
    const entities = this.loggedUser?.entities;
    return !!(entities && entities.length > 1);
  }

  get solutionTypeTranslate(): string {
    if (
      this.balance.deviceType.toUpperCase() === DEVICE_TYPE_AC ||
      this.balance.deviceType.toUpperCase() === DEVICE_TYPE_ACCEPTOR
    ) {
      return this.$i18n.t("solutionType.acceptor");
    } else if (
      this.balance.deviceType.toUpperCase() === DEVICE_TYPE_RE ||
      this.balance.deviceType.toUpperCase() === DEVICE_TYPE_RECYCLER
    ) {
      return this.$i18n.t("solutionType.recycler");
    }
    return this.$i18n.t("solutionType.undefined");
  }

  get mustDisplay(): boolean {
    return !(
      this.balance.deviceType.toUpperCase() === DEVICE_TYPE_RE ||
      this.balance.deviceType.toUpperCase() === DEVICE_TYPE_RECYCLER
    );
  }

  classFirstBalanceItem(index: number): string {
    return index == 0 ? "classFirstBalanceItem" : "";
  }
}
export default BalancesDashboard;
